"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WebGLUnmaskedVendorComponent = void 0;

const webgl_1 = require("../utils/webgl");

const base_1 = require("./base");

class WebGLUnmaskedVendorComponent extends base_1.CustomComponent {
  getValue() {
    var _a, _b;

    const webgl = (0, webgl_1.getWebGLContext)();
    const debugInfo = (_a = webgl === null || webgl === void 0 ? void 0 : webgl.getExtension) === null || _a === void 0 ? void 0 : _a.call(webgl, 'WEBGL_debug_renderer_info');
    let value = '';

    if (webgl && debugInfo) {
      value = (_b = webgl.getParameter) === null || _b === void 0 ? void 0 : _b.call(webgl, debugInfo.UNMASKED_VENDOR_WEBGL);
    }

    return value;
  }

}

exports.WebGLUnmaskedVendorComponent = WebGLUnmaskedVendorComponent;